import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createCompany,
  fetchAllCompanies,
  updateCompany,
  fetchOneCompany,
  deleteCompany,
} from "services/company";

// Fetch all companies with optional filtering
export const useAllCompanies = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["companies", filters],
    queryFn: () => fetchAllCompanies(filters),
    enabled,
  });
};

// Fetch single company by ID
export const useOneCompany = (id, enabled = true) => {
  return useQuery({
    queryKey: ["company", id],
    queryFn: () => fetchOneCompany(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new company
export const useCreateCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createCompany(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companies"] });
    },
  });
};

// Update existing company
export const useUpdateCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateCompany(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["companies"] });
      queryClient.invalidateQueries({ queryKey: ["company", variables.id] });
    },
  });
};

// Delete company
export const useDeleteCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteCompany(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["companies"] });
      queryClient.invalidateQueries({ queryKey: ["company", id] });
    },
  });
};
